<script>
import ErrorHelper from '../../error-helper';
import CONFIG from '../../config';

export default {
    methods: {
        compareShortName(a, b) {
            return a.shortName.localeCompare(b.shortName);
        },
        async getServiceRequirements() {
            try {
                this.$wait.start('loading service requirements');
                const response = await this.$api.get('service-requirements');
                return response.data.sort(this.compareShortName);
            } catch (error) {
                this.$toast.error(`There was a problem getting service requirements`);
            } finally {
                this.$wait.end('loading service requirements');
            }
        },
        async addServiceRequirement(id, add) {
            try {
                this.$wait.start('loading service requirements');
                const response = await this.$api.put(`service-requirements/${id}`, add);
                this.$toast.success(`'${add.shortName}' added`);
                return response;
            } catch (err) {
                const message = ErrorHelper.composeErrorMessage(`add '${add.shortName}'`, err.response);
                this.$toast.error(message);
            } finally {
                this.$wait.end('loading service requirements');
            }
        },
        async updateServiceRequirement(id, update) {
            try {
                this.$wait.start('loading service requirements');
                const response = await this.$api.put(`service-requirements/${id}`, update);
                this.$toast.success(`'${update.shortName}' updated`);
                return response;
            } catch (err) {
                const message = ErrorHelper.composeErrorMessage(`update '${update.shortName}'`, err.response);
                this.$toast.error(message);
            } finally {
                this.$wait.end('loading service requirements');
            }
        },
        isSpecialServiceRequirement(id) {
            if (!id) {
                return false;
            }
            return CONFIG.specialServiceRequirements.pm250.toUpperCase() === id.toUpperCase() || CONFIG.specialServiceRequirements.pm500.toUpperCase() === id.toUpperCase();
        }
    }
};
</script>


